export const currencyFormatter = (
  amount: number | string = 0,
  format: string = "IN",
  Fraction = 2
) => {
  const currencyMap: Record<string, { locale: string; currency: string }> = {
    IN: { locale: "en-IN", currency: "INR" },
    US: { locale: "en-US", currency: "USD" },
    EU: { locale: "en-GB", currency: "EUR" },
    UK: { locale: "en-GB", currency: "GBP" },
    JP: { locale: "ja-JP", currency: "JPY" },
  };

  const { locale, currency } = currencyMap[format] || currencyMap["IN"];

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: Fraction,
  }).format(Number(amount));
};

export const truncateText = (text: string = "", maxLength: number) => {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + "...";
};

export const formatCreatedBy = (
  createdBy?: {
    firstName?: string;
    lastName?: string;
    role?: { name?: string } | string;
    name?: string;
  } | string
) => {
  if (!createdBy || typeof createdBy === "string") return "-";
  const firstName = createdBy.firstName || "";
  const lastName = createdBy.lastName || "";
  const displayName = `${firstName} ${lastName}`.trim() || createdBy.name || "";
  const roleName =
    typeof createdBy.role === "string"
      ? createdBy.role
      : createdBy.role?.name;

  if (!displayName && !roleName) return "-";
  if (!roleName) return displayName || "-";
  return `${displayName || "User"} (${roleName})`;
};
